import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UtilsService } from './utils.service';
import { MyDatePickerModule } from 'mydatepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Chartconstant } from './chart.constant';
import { ChartComponent } from './chart/chart.component';
import { CapitalizePipe } from './custompipes/capitalize.pipe';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FormsModule } from '@angular/forms';
import { MoreLessComponent } from './more-less/more-less.component';




@NgModule({
  declarations: [ChartComponent, CapitalizePipe,DatepickerComponent, MoreLessComponent],
  imports: [
    CommonModule,
    FormsModule,
    MyDatePickerModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [Chartconstant],
  exports: [ChartComponent,CapitalizePipe,DatepickerComponent,MoreLessComponent]
})
export class UtilsModule {  }
